var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.6922C0 4.33934 4.33935 0 9.6922 0H34.7779C40.1308 0 44.4701 4.33935 44.4701 9.6922V35.9182C44.4701 41.271 40.1308 45.6104 34.7779 45.6104H9.6922C4.33935 45.6104 0 41.271 0 35.9182V9.6922Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7779 0.760173H9.6922C4.75918 0.760173 0.760173 4.75918 0.760173 9.6922V35.9182C0.760173 40.8512 4.75918 44.8502 9.6922 44.8502H34.7779C39.7109 44.8502 43.7099 40.8512 43.7099 35.9182V9.6922C43.7099 4.75918 39.7109 0.760173 34.7779 0.760173ZM9.6922 0C4.33935 0 0 4.33935 0 9.6922V35.9182C0 41.271 4.33935 45.6104 9.6922 45.6104H34.7779C40.1308 45.6104 44.4701 41.271 44.4701 35.9182V9.6922C44.4701 4.33935 40.1308 0 34.7779 0H9.6922Z",
    fill: "#45ABE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4342 7.98169H19.7645C23.2281 7.98169 26.0359 10.7895 26.0359 14.2531V37.6284H24.7056C21.242 37.6284 18.4342 34.8206 18.4342 31.357V7.98169Z",
    fill: "#45ABE1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8864 16.344H30.2167C33.6803 16.344 36.4881 19.1518 36.4881 22.6154V37.6288H35.1578C31.6942 37.6288 28.8864 34.821 28.8864 31.3574V16.344Z",
    fill: "#37D4AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8864 7.98169H30.2167C33.6803 7.98169 36.4881 10.7895 36.4881 14.2531V15.0133H35.1578C31.6942 15.0133 28.8864 12.2055 28.8864 8.74186V7.98169Z",
    fill: "#D7B05B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98169 37.6287H9.31199C12.7756 37.6287 15.5834 34.8209 15.5834 31.3572V14.4434H14.2531C10.7895 14.4434 7.98169 17.2512 7.98169 20.7148V37.6287Z",
    fill: "#89CFF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small_logo.9749dc112a2a35696e69a82e5a7c9810.svg";
export { ForwardRef as ReactComponent };